<template>
  <v-container>
    <v-row>
      <v-col class="d-flex align-start mb-6">
        <span class="text-left" style="white-space: pre-wrap">
          {{ `${numText}: ${questionText}` }}
        </span>
        <span v-if="required" class="red--text text--lighten-1">*</span>
      </v-col>
      <v-col>
        <v-textarea v-model="response" outlined label="ここに記入してください" @input="update" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TextFrom',
  props: {
    questionText: {
      type: String,
      required: true
    },
    numText: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      response: ''
    }
  },
  methods: {
    update: function () {
      this.$emit('update', this.response)
    }
  }
}
</script>
